<template>
  <div id="self-introduction">
    <section id="header">
      <div class="picture">
        <div class="frame">
          <img src="../assets/logo.jpg" alt="headImage">
        </div>
        <ul class="circle-list">
          <li><a href="https://github.com/yuanyayi" target="_blank"><i class="fa fa-github"></i>github</a></li>
          <li><a href="https://www.jianshu.com/u/64f0eb4f9ad2" target="_blank" style="color: #ea6f5a">简书</a></li>
        </ul>
      </div>
      <div>
        <p>你好！这里是袁雅宜的个人网站！我在首都师范大学计算机科学与技术专业获得了本科学历，现在从事前端开发方面的工作。</p>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'self-introduction'
  }
</script>

<style lang="sass">
  @import 'assets/style/variable.sass'
  #self-introduction
    position: relative
    padding: 1px
    section
      position: relative
      width: 50%
      // background: rgba(255,255,255, .7)
      border-radius: 20px
      margin: 100px auto
      padding: 50px 100px 50px 50px
      color: #fff
      font-size: 1.18em
      p
        text-indent: 2em
      p::first-word 
        font-size: 130%;
    .picture
      position: absolute
      right: -80px
      top: 30%
      transform: translateY(-50%)
      $width: 160px
      color: #333
      .frame
        width: $width
        height: $width
        border-radius: 50%
        img
          height: 100% 
          width: auto
      .circle-list
        position: absolute
        left: 55%
        top: 50%
        transform: translate(-50%, -50%)
        $deg: -15deg
        li
          background: #fff
          border-radius: 10px
          padding: 3px 5px
          transform-origin: -$width*3/4
          text-align: center
          position: absolute
          width: 100px
          box-shadow: 2px 1px 2px $light-theme
          i 
            margin-right: 3px
        li:first-child
          transform: translateX($width/2) rotate($deg * 0)
        li:nth-child(2)
          transform: translateX($width/2) rotate($deg * 1)
</style>


// WEBPACK FOOTER //
// src/components/SelfIntroduction.vue